(function () {

  const sliderComponent = document.querySelector('slider-component');
  if (!sliderComponent) return;

  const slider = sliderComponent.querySelector('.slider');
  const slides = sliderComponent.querySelectorAll('.slider__slide');
  const dotsWrap = sliderComponent.querySelector('.slider-dots');

  if (!slider || !slides.length || !dotsWrap) return;

  /* Build dots */
  dotsWrap.innerHTML = '';
  slides.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.className = 'slider-dot';
    dot.type = 'button';
    dot.addEventListener('click', () => {
      slider.scrollTo({
        left: slides[index].offsetLeft,
        behavior: 'smooth'
      });
    });
    dotsWrap.appendChild(dot);
  });

  const dots = dotsWrap.querySelectorAll('.slider-dot');

  /* Update active dot based on scroll position */
  function updateActiveDot() {
    const scrollLeft = slider.scrollLeft;

    let activeIndex = 0;
    slides.forEach((slide, index) => {
      if (scrollLeft >= slide.offsetLeft - slide.offsetWidth / 2) {
        activeIndex = index;
      }
    });

    dots.forEach(d => d.classList.remove('is-active'));
    dots[activeIndex]?.classList.add('is-active');
  }

  /* Listen to scroll (THIS IS THE KEY FIX) */
  slider.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateActiveDot);
  });

  /* Init */
  updateActiveDot();

})();